import Box from '@mui/material/Box';

import { ClientLogoStrip } from 'src/components/cmui/client-logos/client-logo-strip';

import { SECTION_PX } from '../constants/home-theme';

// ----------------------------------------------------------------------

/** 홈의 고객사 로고 구역 — 띠 자체는 공용 `ClientLogoStrip` 이 그린다 */
export function HomeLogoStripSection() {
  return (
    <Box data-section-id="logos" sx={{ px: SECTION_PX, py: { xs: 4, md: 6 } }}>
      <ClientLogoStrip />
    </Box>
  );
}
